import { Env } from 'types/env/Env.type';

export const getCurrentAuthMethod = (env: Env) => {
  return {
    isUsingAfSso: env.auth.method === 'afSso',
    isUsingClient: env.auth.method === 'client'
  };
};
